import { FieldWrapper } from "@progress/kendo-react-form";

import { DomainType } from "models";

import { CardRadioButton } from "./CardRadioButton";

import type { FieldRenderProps } from "@progress/kendo-react-form";

interface DomainRadioGroupFieldProps extends Partial<FieldRenderProps> {
  name: string;
  onChange: FieldRenderProps["onChange"];
}

export const DomainRadioGroupField = ({ name, value, onChange }: DomainRadioGroupFieldProps) => {
  const handleChange = (event: { value: string }) => {
    onChange({ target: name, value: event.value });
  };

  return (
    <FieldWrapper>
      <div className="k-d-flex k-gap-4">
        <CardRadioButton
          name={name}
          value={DomainType.Facility}
          onChange={handleChange}
          checked={value === DomainType.Facility}
          label="Facility Encounter"
          description="Add patient encounter to Facility"
          id={`${name}-${DomainType.Facility}`}
        />

        <CardRadioButton
          name={name}
          value={DomainType.Practice}
          onChange={handleChange}
          checked={value === DomainType.Practice}
          label="Professional Encounter"
          description="Add patient encounter to Practice"
          id={`${name}-${DomainType.Practice}`}
        />
      </div>
    </FieldWrapper>
  );
};
